<template>
  <div class="grow">
    <div v-if="booking && survey">
      <h2 class="mb-4">
        {{ t('customerSurvey') }}
      </h2>

      <HandoverSurveyForm :booking="booking" :survey="survey" @submit="handleSubmit" />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { useI18n } from 'vue-i18n';
import { useBooking } from '@/queries/use-bookings';
import { useRoute } from 'vue-router';
import { useSurvey } from '@/queries/use-surveys';
import HandoverSurveyForm from './HandoverSurveyForm.vue';
import { useProcessNavigation } from '@/hooks/use-process-step-tracking';

const { t } = useI18n();
const route = useRoute();
const { goToNext } = useProcessNavigation();

const { data: booking } = useBooking(route.params.id as string);
const { data: survey } = useSurvey(route.params.surveyId as string);

const handleSubmit = async () => {
  goToNext();
};
</script>

<i18n lang="json">
{
  "en": {
    "customerSurvey": "Customer Survey"
  },
  "de": {
    "customerSurvey": "Kundenumfrage"
  },
  "es": {
    "customerSurvey": "Encuesta al cliente"
  }
}
</i18n>
